export enum TradeStatusEnum {
  Aberto = "Aberto",
  Rejeitado = "Rejeitado",
  Aprovado = "Aprovado",
  Negociando = "Negociando",
  Pendencia = "Pendencia",
  PendenciaEnviada = "PendenciaEnviada"
}

export const getStatusesList = () => Object.keys(TradeStatusEnum);